import { render, staticRenderFns } from "./JobNone.vue?vue&type=template&id=2c52ab0c&scoped=true&"
import script from "./JobNone.vue?vue&type=script&lang=js&"
export * from "./JobNone.vue?vue&type=script&lang=js&"
import style0 from "./JobNone.vue?vue&type=style&index=0&id=2c52ab0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c52ab0c",
  null
  
)

export default component.exports